import { useEffect, useState } from 'react'
import { useReducedMotion } from './useReducedMotion'

export type WechatMediaMode =
  | 'VIDEO'
  | 'WECHAT_ANIMATED_WEBP'
  | 'POSTER'

export function useWechatMediaEnvironment() {
  const [detectedWechat] = useState(() =>
    typeof navigator === 'undefined'
      ? false
      : navigator.userAgent.includes('MicroMessenger'),
  )
  const [debugMediaMode] = useState<WechatMediaMode | undefined>(() => {
    if (!import.meta.env.DEV || typeof window === 'undefined') return undefined

    const requestedMode = new URLSearchParams(window.location.search).get(
      'mediaMode',
    )

    return requestedMode === 'VIDEO' ||
      requestedMode === 'WECHAT_ANIMATED_WEBP' ||
      requestedMode === 'POSTER'
      ? requestedMode
      : undefined
  })
  const isWechat = debugMediaMode
    ? debugMediaMode !== 'VIDEO'
    : detectedWechat

  return { debugMediaMode, isWechat }
}

export function useWechatMediaMode() {
  const { debugMediaMode, isWechat } = useWechatMediaEnvironment()
  const systemReduceMotion = useReducedMotion()
  const reduceMotion = debugMediaMode
    ? debugMediaMode === 'POSTER'
    : systemReduceMotion
  const mediaMode: WechatMediaMode = isWechat
    ? reduceMotion
      ? 'POSTER'
      : 'WECHAT_ANIMATED_WEBP'
    : 'VIDEO'

  useEffect(() => {
    if (!import.meta.env.DEV) return

    document.documentElement.dataset.mediaMode = mediaMode

    return () => {
      delete document.documentElement.dataset.mediaMode
    }
  }, [mediaMode])

  return { isWechat, mediaMode, reduceMotion }
}
